import React from 'react'
import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField, Select, MenuItem } from '@material-ui/core'

function BusinessConfig3() {
  const roles = [
    { value: 1, label: 'Regional' },
    { value: 2, label: 'Zonal' },
    { value: 3, label: 'State' },
    { value: 4, label: 'City' },
    { value: 5, label: 'District' },
    { value: 6, label: 'Area' },
  ]

  const content = [
    { heading: 'Who can add employees to your company' },
    { heading: 'Who can upload and download bulk data' },
    { heading: 'Who can change the Attendance of employee' },
    { heading: 'Who can change the status of lead' },
  ]
  return (
    <div>
      <Grid container>
        {content.map((item, index) => (
          <Grid container style={{ marginBottom: '20px' }}>
            <Grid item xs={6}>
              <Typography> {item.heading} </Typography>
            </Grid>
            <Grid item xs={6}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                //   value={item.value}
                //   onChange={item.handleChange}
                style={{ width: '40%' }}
              >
                {roles.map((item, index) => (
                  <MenuItem value={item.value}> {item.label} </MenuItem>
                ))}
                {/* <MenuItem value="Supervisor">Supervisor</MenuItem> */}
              </Select>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default BusinessConfig3
